var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11C0 4.92487 4.92487 0 11 0V0C17.0751 0 22 4.92487 22 11V11C22 17.0751 17.0751 22 11 22V22C4.92487 22 0 17.0751 0 11V11Z",
    fill: "#1DB954"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9714 5.38788V3.36384C10.9714 3.03739 10.5647 2.87778 10.3313 3.10993L7.46935 5.85943C7.31872 6.00452 7.31872 6.22941 7.46935 6.3745L10.3237 9.124C10.5647 9.34889 10.9714 9.18929 10.9714 8.86283V6.8388C13.7807 6.8388 16.0024 9.31987 15.3848 12.1274C15.0309 13.7742 13.6451 15.1018 11.943 15.4428C9.25429 15.9868 6.8593 14.2095 6.4978 11.8082C6.44508 11.46 6.12876 11.1916 5.75972 11.1916C5.30784 11.1916 4.94633 11.5761 5.00658 12.0113C5.47353 15.1961 8.62165 17.5538 12.184 16.8864C14.5338 16.4439 16.4242 14.623 16.8836 12.3595C17.6292 8.63794 14.6919 5.38788 10.9714 5.38788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group 3.0d4fa8ffdea61f33c69c7341bf7d4c28.svg";
export { ForwardRef as ReactComponent };